import type {
  InsertDepartmentTypeWithOptionalGroupIdMutation,
  InsertDepartmentTypeWithOptionalGroupIdMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertDepartmentTypeWithOptionalGroupIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useInsertDepartmentTypeWithOptionalGroupId = createMutationHook({
  name: 'insertDepartmentTypeWithOptionalGroupId',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.department.insertTypeWithGroupId.mutationOptions({
      onSuccess,
    }),
  mapInput: (
    variables: InsertDepartmentTypeWithOptionalGroupIdMutationVariables
  ): {
    Name: string;
    Description?: string | null;
    DepartmentTypeGroupId?: string | null;
  } => {
    if (!variables.Name) {
      throw new Error('Name is required');
    }

    return {
      Name: variables.Name,
      Description: variables.Description,
      DepartmentTypeGroupId: variables.DepartmentTypeGroupId,
    };
  },
  invalidate: (trpc) => [
    trpc.frontend.department.allTypes.queryKey(),
    trpc.frontend.department.departmentTypeGroups.queryKey(),
  ],
  mapResponse: (result: {
    Id: string;
  }): InsertDepartmentTypeWithOptionalGroupIdMutation => ({
    insert_department_type_one: {
      __typename: 'department_type',
      DepartmentTypeId: result.Id,
    },
  }),
  graphqlDocument: InsertDepartmentTypeWithOptionalGroupIdDocument,
  graphqlVariables: (
    variables: InsertDepartmentTypeWithOptionalGroupIdMutationVariables
  ) => ({ ...variables }),
  evictFields: ['department_type', 'department_type_group'],
});
